import { Upload } from 'lucide-react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useMensalidades } from '@/context/MensalidadesContext';

/**
 * Botao "Carregar ficheiro" — abre file picker e chama loadFromFile('manual').
 * Visivel no AppHeader em qualquer estado (PROMPT_DASHBOARD §5.2: "Botao
 * 'Recarregar' no header sempre disponivel").
 */
export function FilePicker() {
  const { loadFromFile, state } = useMensalidades();
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  const onChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      await loadFromFile(file, 'manual');
    }
    // Reset para permitir recarregar o mesmo ficheiro consecutivamente
    if (inputRef.current) inputRef.current.value = '';
  };

  return (
    <>
      <button
        type="button"
        className="aiobi-icon-btn"
        onClick={() => inputRef.current?.click()}
        disabled={state.status === 'loading'}
        title={t('header.loadFile')}
        aria-label={t('header.loadFile')}
      >
        <Upload size={14} />
        <span>{t('header.loadFile')}</span>
      </button>
      <input
        ref={inputRef}
        type="file"
        accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        onChange={onChange}
        style={{ display: 'none' }}
        aria-hidden="true"
      />
    </>
  );
}
